import React, { useEffect, useState } from "react";
import Select,{components, createFilter} from "react-select";
import { useController, Controller } from "react-hook-form";
import {AiOutlineClose} from "react-icons/ai"
import { shallowEqual, useSelector } from "react-redux";
const Input = (props) => <components.Input {...props} isHidden={false} />;

export const ReactSelectField = React.forwardRef((props, ref = null) => {
  const {  practiceID } = useSelector(
    ({ auth }) => ({
      practiceID: auth && auth.practice_id,
    }),
    shallowEqual
  );
  const [focusState, setFocusState] = useState(false);
  const [inputValue, setInputValue] = useState();
  const {
    isDisabled=false,
    title,
    style,
    type,
    errors,
    defaultValue,
    onChange,
    isMulti = false,
    onFocus,
    onBlur,
    capitalize = true,
    menuPlacement,
    isHighLight=false,
    ellipses,
    showMenuOnTop=false,
    maxMenuHeight,
    placeholderHeight=false,
    getOnlyValue,
    getValueLabel,
    editableInput,
    matchFromStart,
    ...others
  } = props;
  const { field, fieldState,formState } = useController(props);
  
  let err = _.get(errors, props.name);
  const handleInputChange = (e) => {
    setInputValue(e)
    if (props.onInputChange) {
      props.onInputChange(e);
    }
    // setInputValue(e);
    if (props.handleSelectOption) {
      props.handleSelectOption(e);
    }
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: !isMulti?35:"100%",
      minHeight: props.minHeight ? props.minHeight : 35,
      maxHeight: "100%",
      boxShadow: "none",
      background: isHighLight ? "#feffd7":isDisabled?"#f3f4f6":"",
      border: props.rules && err && "1px solid #dc2626",
      backgroundColor: props?.backgroundColor ? props?.backgroundColor : ''
      
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: 50,
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
  };
  const getOptionLabel = (e) => {
    if (props.getOptionLabel) {
      return props.getOptionLabel(e);
    } else {
      return e[props.showLabel || "label"];
    }
  };
  const onCrossHandler = (event) => {
    // console.log(
    //   "🚀 ~ file: ReactSelectField.js:47 ~ onCrossHandler ~ event",
    //   event
    // );
  };

  const filterConfig = {
    ignoreCase:matchFromStart,
    matchFrom: matchFromStart ? 'start' : 'any',
  };
  const customComponentsForClearValue = {
    ClearIndicator: (props) => (
      <div onClick={handleClearValue} {...props.innerProps}>
        Custom Clear
      </div>
    ),
  };
  
  return (
    <>
      <div className={`relative ${props?.dropdownClass ? props?.dropdownClass : 'w-full'} bg-white text-gray-500 rounded ${isDisabled && " cursor-not-allowed " }`}>
        <label
          htmlFor="name"
          className={`${props?.labelClassname ? props?.labelClassname : 'bg-white'} ${props?.labelZIndex ? props?.labelZIndex : ' z-10'} pointer-events-none absolute  bg-white left-2 mt-1 inline-block px-2  
                    ${isDisabled && "  bg-gray-100 cursor-not-allowed "}
                    ${isHighLight && " bg-highLight  "}

                    ${props.rules && err ? "text-red-600" : "text-gray-600"} 
                    ${
                      focusState || ((field?.value !== null && field.value && !Array.isArray(field.value))|| (Array.isArray(field.value) && field?.value?.length>0))
                        ? `-top-2 duration-300 ${props?.labelBig ? 'text-sm' : 'text-xs'} rounded-lg ${ellipses && 'max-w-[88.2%] text-ellipsis overflow-hidden whitespace-nowrap'}`
                        : `custom-top duration-300 ${props?.labelBig ? 'text-lg' : (props?.fontcls ? props?.fontcls : ' text-base')} font-normal ${ellipses && 'w-[73.2%] text-ellipsis overflow-hidden whitespace-nowrap'}`
                    }`}
        >
          {title}{" "}
          {props?.rules?.required?.value === true && (
            <span className="text-red-500 mt-10">*</span>
          )}
        </label>
        <Controller
          name={props?.name}
          rules={props?.rules}
          control={props?.control}
          defaultValue={defaultValue}
          render={({ field: { onChange } }) => (
            <Select
              {...field}
              {...others}
              ref={ref || field.ref}
              // openMenuOnClick={()=>{console.log("sasa")}}
              inputValue={editableInput ? inputValue : undefined}
              components={ props?.CustomOption ? {Input, Option: props?.CustomOption}: editableInput ? {Input}:null}
              menuPortalTarget={ showMenuOnTop && document.body} 
              maxMenuHeight={maxMenuHeight}
              isLoading={props.isLoading || false}
              noOptionsMessage={() => null}
              getOptionLabel={getOptionLabel}
              styles={customStyles ? customStyles : style}
              isSearchable={true}
              options={props?.optionData}
              placeholder={props?.placeholder? props?.placeholder : ""}
              menuPlacement={menuPlacement || "auto"}
              className={`placeholder:text-black 
                            placeholder:font-normal
                            placeholder:text-base ui-control-input focus:border-teal-c-900 text-start ${
                              capitalize && "capitalize"
                            }  ${placeholderHeight ? placeholderHeight : ''}`}
              isClearable={(getOnlyValue&& !isMulti)?false :true}
              defaultOptions
              onChange={(val, action) => {
                if (getOnlyValue && isMulti){
                  onChange(val?.map((v,k)=>(v[getValueLabel])))
                }
               else if (getOnlyValue){
                  onChange(val[getValueLabel]);
                }else{
                onChange(val);
              }
                if (props.onChange) {
                  props.onChange(val, action);
                }
                setInputValue(val ? val[getValueLabel || "label" ] :"")
              }}
              
              value={(getOnlyValue && field.value && isMulti) ? ( typeof field?.value == 'string') ? field?.value?.split(",").map((v,k)=>({[getValueLabel]:v})): field?.value?.map((v,k)=>({[getValueLabel]:v})):(getOnlyValue && field.value) ?props?.optionData?.find(o => o[getValueLabel || ""] == field.value):field.value}
              menuIsOpen={props.menuIsOpen || undefined}
              onFocus={(e) => {
                setInputValue(field?.value ? field?.value[getValueLabel || "label" ]:"")
                setFocusState(true);
                if (props.onFocus) {
                  props.onFocus(e);
                }
              }}
              onBlur={(e) => {
                field.onBlur;
                setFocusState(false);
                if (props.onBlur) {
                  props.onBlur(e);
                }
              }}
              isDisabled={isDisabled ?isDisabled:false}
              onInputChange={handleInputChange}
              getOptionValue={(option) => option[props.showLabel || "label"]} // changes here!!!
              // styles={customStyles}
              onMenuClose={() => onCrossHandler()}
              isOptionDisabled={(option) => option.disabled}
              isMulti={isMulti}
              filterOption={(matchFromStart) ? createFilter(filterConfig):undefined}
              {...others}
              
            />
          )}
              
/>
       {(getOnlyValue && field.value && !isMulti)&&
        <div className="absolute top-2 right-12 z-[999] text-lg" onClick={(e)=>{
        props.setValue(props.name,null)
      }}> <AiOutlineClose/></div>}  
      {props.rules && err && props.rules && err?.message ? (
        <div className="absolute">
          <p className=" text-xs text-red-600 h-3 text-left" id="email-error">
            {props.rules && err && props.rules && err?.message}
          </p>
        </div>
      ) : (
        ""
      )}
      </div>
    </>
  );
});
